import { EntityReferences, ExternalEntityReferences } from "../models/mappers";
import { EntityName, ExternalEntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const accountFields = [
  "accountid", // UID
  "parentaccountid", // Lookup - parent account
  "statecode", // Choice
  "statuscode", // Choice
  "modifiedon", // Date
  "name", // Text
  "gaming_istestdata", // Boolean
  "gaming_mspcverifiedaccountname", // Text
  "ggp_legalentitynameifdifferent", // Text
  "ggp_businessimpact", // Choice
  "ggp_primaryaccounttype", // Choice
  "ggp_secondaryaccounttype", // Choice
  "ggp_accounttype", // Choice
  "ggp_udcsellerid", // Text
  "playfab_leadsource", // Choice
  "playfab_leadsourcedetailed", // Text
  "gaming_Address1CountryRegionId", // Lookup - country/region
  "address1_line1", // Text
  "address1_line2", // Text
  "address1_city", // Text
  "address1_stateorprovince", // Text
  "address1_postalcode", // Text
  "address1_telephone1", // Phone
  "address1_addresstypecode", // Choice
  "address1_country", // Text
  "address2_line1", // Text
  "address2_line2", // Text
  "address2_city", // Text
  "address2_stateorprovince", // Text
  "address2_postalcode", // Text
  "gaming_Address2CountryRegionId", // Lookup - country/region
  "address2_country", // Text
  "address2_telephone1", // Phone
  "address2_addresstypecode", // Choice
  "telephone1", // Phone
  "gaming_dsa_addressline1",
  "gaming_dsa_addressline2",
  "gaming_dsa_city",
  "gaming_dsa_stateorprovidence",
  "gaming_dsa_postalcode",
  "gaming_DSA_CountryRegionId",
  "gaming_dsa_telephone",
  "gaming_dsa_emailaddress",
  "gaming_dsa_websiteurl",
  "primarycontactid", // Lookup - contacts
  "gaming_PrimarySignatoryId", // Lookup - contacts
  "gaming_HubLastUpdateByContactId", // Lookup - contact
  "ownerid", // Owner
  "websiteurl", // Text
  "gaming_soleproprietor", // Boolean
  "gaming_onboardinghubcreated", // Boolean
  "gaming_onboardingndaid", // GUID
  "gaming_ndacontractnumber", // Text
  "gaming_ndasentdate", // Date
  "gaming_ndaonfile", // Choice - YesNo
  "gaming_ndasigneddate", // Date
  "gaming_hubaccess", // Choice
  "gaming_onboardingpcenrollmentreferenceid", // Text
  "gaming_onboardingpartnercenterenrollmentstatus", // Choice
  "gaming_onboardingpartnercenterenrollmentdate", // Date
  "gaming_onboardingpartnercenterenrollmentdescription", // Text
  "gaming_pcenrollmentrejectreason", // Text
  "gaming_partnercentertokenhash", // Text
  "gaming_dunsnumber", // Text
  "ggp_msvendorid", // Text
  "gaming_partnercentertokenhash", // Text
  "gaming_ndaapierrormessage", // Text
  "gaming_creatorclassification", // Choice
  "gaming_tlastatus", // Choice
  "gaming_plastatus", // Choice
  "gaming_windowsresellerstatusnew", // Choice
  "gaming_gdkcontractnumber", // Text
  "gaming_gdkeffectivedate", // Date
  "gaming_adaaeffectivedate", // Date

  // Partner Center Enrollment
  "gaming_pcreconcilestatus", // Text
  "gaming_pcearlyenrollopendev", // Choice - YesNo
  "gaming_partnercenterearlyenrollmentcreateddatetime", // Date
  "gaming_pcpreexistingaccount", // Text
  "gaming_partnercenterpreexistingacctcreateddatetime", // Date

  // Re Send NDA
  "gaming_sendnewnda", // Choice - YesNo
  "gaming_ndaresendapistatus", // Choice
  "gaming_ndaresendapiresponse", // Text
  "gaming_historicalonboardingndaid", // Text
  "gaming_historicalndasigneddate", // Date
  "gaming_historicalndacontractnumber", // Text

  // OneVet
  "gaming_vettingcompanyemail", // Text
  "gaming_vettingid", // Text
  "gaming_vettingstatus", // Choice
  "gaming_vettingemailverificationstatus", // Choice
] as const;

export const accountReferences: EntityReferences<EntityName.account> = {
  [EntityName.account]: ["parentaccountid"],
  [EntityName.ggp_country]: [
    "gaming_Address1CountryRegionId",
    "gaming_Address2CountryRegionId",
    "gaming_DSA_CountryRegionId",
  ],
  [EntityName.contact]: [
    "gaming_PrimarySignatoryId",
    "gaming_HubLastUpdateByContactId",
    "primarycontactid",
  ],
};

export const accountExternalReferences: ExternalEntityReferences<EntityName.account> = {
  [ExternalEntityName.team]: ["ownerid"],
};

export const accountKey: AnyEntityField<EntityName.account> = "accountid";
